<template>
    <v-card flat>
        <v-card-text>
            <v-data-table
                    :headers="headers"
                    :items="faultsummary"
                    class="elevation-1"
            >
      <template v-slot:items="props">
        <td>{{ props.item.issue }}</td>
        <td class="text-xs-left">{{ props.item.value }}</td>
          <td class="text-xs-left">
              <severity-chip :value="props.item.severity"></severity-chip>
          </td>
        <td class="text-xs-left">{{ props.item.cost}}</td>
          <td class="text-xs-left">
              <span v-if="totalTime">{{ Math.round(props.item.value/totalTime*100) }}</span>
              <span v-if="!totalTime">0</span>
              %
          </td>
        <td class="text-xs-left">{{ props.item.timestamp }}</td>
        <td class="text-xs-left">
            <v-icon v-if="equipmentName"
                    small
                    @click="jumpToLink(props.item)"
            >
                fa-chart-line
            </v-icon>
        </td>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="refresh">Refresh</v-btn>
      </template>
    </v-data-table>
        </v-card-text>
    </v-card>
</template>

<script>
    import {getIssueSummary, getRule} from '../../helper'
    import SeverityChip from '@/components/SeverityChip.vue'
    import _ from 'lodash'
    import moment from 'moment'

    export default {
    name: 'FaultSummary',
      components: {SeverityChip},

      props: {
      range: {type: Object, default: null},
      facilityName: String,
      equipmentName: String
    },
    data() {
      return {
        rules:{},
        headers: [
        {
          text: 'Issue',
          align: 'left',
          sortable: true,
          value: 'issue'
        },
        { text: 'Active (hr)', value: 'value' },
          {text: 'Severity', value: 'severity'},
          {text: 'Cost', value: 'cost'},
        { text: 'Active (as % of on time)', value: 'value' },
        { text: 'Last Detected', value: 'timestamp' },
        {text: 'Actions', value: 'name', sortable: false}
      ],
        faultsummary: [],
        totalTime: 1.0,
        totalOnTime: 1.0
      }
    },
    watch: {
      range () {
        this.refresh()
      },
      facilityName () {
        this.refresh()
      },
      equipmentName () {
        this.refresh()
      }
    },
    methods: {
        jumpToLink(item) {
            if(!this.equipmentName){
                return
            }
            let output = null;
            let myrule=null;
            for (let rule of this.rules) {
                if(rule.title==item.issue){
                    myrule=rule
                    break
                }
            }
            if(myrule){
                output = {
                    path: '/fault-analysis',
                    query: {
                        relevantVariables: myrule.relevant_variables,
                        faultName: myrule.title,
                        faultDesc: myrule.desc,
                        rangeStart: moment(item.timestamp).subtract(1,'days').format('YYYY-MM-DD HH:mm:ss'),
                        rangeEnd: moment(item.timestamp).add(1,'days').format('YYYY-MM-DD HH:mm:ss'),
                        equipmentName:this.equipmentName
                    }
                }
            }
            this.$router.push(output)
        },
      async refresh() {
        if (!this.range.start) return
        let result = await getIssueSummary({
          'facility_name': this.facilityName,
          'equipment_name': this.equipmentName,
          'date_range': this.range
        })
        this.faultsummary = result['summary']
        this.totalTime = result['total_time']
        this.totalOnTime = result['total_on_time']

        let severity_arr = {}

        let rules = await getRule({'facility_name': this.$store.state.pointsListStore.pointsList.facility_name})

        this.rules=rules.result;
        for (let i in rules.result) {
          severity_arr[rules.result[i]['title']]=rules.result[i]['severity']
        }
        function mapper(x){
              return {
                  'cost': x.cost ,
                  'timestamp': x.timestamp,
                  'value': x.value,
                  'severity': _.get(severity_arr, x['issue'], 'Low'),
                  'issue': x['issue']
              }
        }

        this.faultsummary = _.map(this.faultsummary, mapper)
      }
    },
    mounted () {
      this.refresh()
    }
  }
</script>

<style scoped>

</style>
